import { makeAutoObservable } from "mobx";
import type {
  Application,
  ListApplicationsResponse,
} from "@smartsuite/automation-engine-api";

export class ApplicationStore {
  list: Application[] = [];
  selectedApplicationId?: string;

  constructor() {
    makeAutoObservable(this);
  }

  setList(applicationList: ListApplicationsResponse): void {
    this.list = applicationList.applications;
    if (this.selectedApplicationId === undefined && this.list.length > 0) {
      this.selectedApplicationId = this.list[0].id;
    }
  }
}
